import { useEffect, useState } from "react";

const useIsOtherContain = (val: { text?: string }) => {
  const [isOtherContain, setIsOtherContain] = useState(false);

  useEffect(() => {
    let isConsist = ["other", "others"].some((keyword) =>
      val?.text?.toLocaleLowerCase().includes(keyword),
    );
    setIsOtherContain(isConsist);
  }, [val]);

  return isOtherContain;
};

export default useIsOtherContain;
